import React from 'react';
import { Section, FormValues, FileState } from '@/types/platform';
import ComponentRenderer from './ComponentRenderer.tsx';
import './SectionRenderer.css';

interface SectionRendererProps {
  section: Section;
  formValues: FormValues;
  files: FileState;
  onValueChange: (name: string, value: any) => void;
  onFileChange: (name: string, files: File[]) => void;
  getTranslation: (key: string) => string;
}

const SectionRenderer: React.FC<SectionRendererProps> = ({
  section,
  formValues,
  files,
  onValueChange,
  onFileChange,
  getTranslation,
}) => {
  const getLayoutClass = () => {
    if (section.layout === 'grid') {
      return `section-grid section-grid-cols-${section.columns || 2}`;
    }
    return 'section-column';
  };

  return (
    <div className="section-card">
      <div className={getLayoutClass()}>
        {section.components.map((component, index) => (
          <ComponentRenderer
            key={`${component.name}-${index}`}
            component={component}
            value={formValues[component.name]}
            files={files[component.name] || []}
            formValues={formValues}
            onValueChange={onValueChange}
            onFileChange={onFileChange}
            getTranslation={getTranslation}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionRenderer;
